<template>
  <div class="sv-texteditor-container">
    <!-- eslint-disable -->
    <div v-if="editor" class="sv-texteditor-toolbar">
      <div class="sv-texteditor-toolbar-row" v-show="isHtml">
        <tbtn
          icon="mdi-undo"
          title="Отменить"
          @click="editor.chain().focus().undo().run()"
        />
        <tbtn
          icon="mdi-redo"
          title="Повторить"
          @click="editor.chain().focus().redo().run()"
        />
        <tbtn
          icon="mdi-format-paragraph"
          :active="editor.isActive('paragraph')"
          title="Параграф"
          @click="editor.chain().focus().setParagraph().run()"
        />
        <tbtn
          icon="mdi-format-header-3"
          :active="editor.isActive('heading', { level: 3 })"
          title="Заголовок 3 уровня"
          @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
        />
        <tbtn
          icon="mdi-format-header-4"
          :active="editor.isActive('heading', { level: 4 })"
          title="Заголовок 4 уровня"
          @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
        />
        <tbtn
          icon="mdi-format-header-5"
          :active="editor.isActive('heading', { level: 5 })"
          title="Заголовок 5 уровня"
          @click="editor.chain().focus().toggleHeading({ level: 5 }).run()"
        />
        <tbtn
          icon="mdi-format-header-6"
          :active="editor.isActive('heading', { level: 6 })"
          title="Заголовок 6 уровня"
          @click="editor.chain().focus().toggleHeading({ level: 6 }).run()"
        />
        <tbtn
          icon="mdi-alert-decagram-outline"
          :active="editor.isActive('notification')"
          title="Уведомление"
          @click="editor.chain().focus().toggleNotification().run()"
        />
        <tbtn
          icon="mdi-format-quote-close"
          :active="editor.isActive('blockquote')"
          title="Цитата"
          @click="editor.chain().focus().toggleBlockquote().run()"
        />
        <tbtn
          icon="mdi-format-list-bulleted-square"
          :active="editor.isActive('bulletList')"
          title="Маркированный список"
          @click="editor.chain().focus().toggleBulletList().run()"
        />
        <tbtn
          icon="mdi-format-list-numbered"
          :active="editor.isActive('orderedList')"
          title="Нумерованный список"
          @click="editor.chain().focus().toggleOrderedList().run()"
        />
        <tbtn
          icon="mdi-format-align-left"
          :active="editor.isActive({ textAlign: 'left' })"
          title="По левому краю"
          @click="editor.chain().focus().setTextAlign('left').run()"
        />
        <tbtn
          icon="mdi-format-align-center"
          :active="editor.isActive({ textAlign: 'center' })"
          title="По центру"
          @click="editor.chain().focus().setTextAlign('center').run()"
        />
        <tbtn
          icon="mdi-format-align-right"
          :active="editor.isActive({ textAlign: 'right' })"
          title="По правому краю"
          @click="editor.chain().focus().setTextAlign('right').run()"
        />
      </div>
      <div class="sv-texteditor-toolbar-row" v-show="isHtml">
        <tbtn
          icon="mdi-format-clear"
          title="Очистить формат"
          @click="editor.chain().focus().unsetAllMarks().run()"
        />
        <tbtn
          icon="mdi-format-bold"
          :active="editor.isActive('bold')"
          title="Полужирный"
          @click="editor.chain().focus().toggleBold().run()"
        />
        <tbtn
          icon="mdi-format-italic"
          :active="editor.isActive('italic')"
          title="Курсив"
          @click="editor.chain().focus().toggleItalic().run()"
        />
        <tbtn
          icon="mdi-format-underline"
          :active="editor.isActive('underline')"
          title="Подчеркнутый"
          @click="editor.chain().focus().toggleUnderline().run()"
        />
        <tbtn
          icon="mdi-format-strikethrough"
          :active="editor.isActive('strike')"
          title="Зачеркнутый"
          @click="editor.chain().focus().toggleStrike().run()"
        />
        <tbtn
          icon="mdi-link-box-variant-outline"
          :active="editor.isActive('link', { class: 'aunfbutton' })"
          title="Ссылка-кнопка"
          @click="setButtonLink"
        />
        <tbtn
          icon="mdi-link-variant"
          :active="editor.isActive('link') && !editor.isActive('link', { class: 'aunfbutton' })"
          title="Ссылка"
          @click="setLink"
        />
        <tbtn
          icon="mdi-link-variant-off"
          :disabled="!editor.isActive('link')"
          title="Убрать ссылку"
          @click="editor.chain().focus().unsetLink().run()"
        />
        <tbtn
          icon="mdi-file-document"
          :active="editor.isActive('fileattach')"
          title="Файл для скачивания"
          @click="setFileAttach"
        />
        <tbtn
          icon="mdi-image-search"
          :active="editor.isActive('image')"
          title="Изображение с сервера"
          @click="setImage"
        />
        <uploader-button
          :work-dir="editor.imagesUploadDir"
          class="d-block"
          @upload-success="onImageUpload"
          @upload-error="onUploadError"
        >
          <tbtn
            icon="mdi-image-plus"
            title="Загрузить изображение"
          />
        </uploader-button>
        <tbtn
          icon="mdi-message-image"
          :active="editor.isActive('imagecaption')"
          title="Подпись к изображению"
          @click="editor.chain().focus().toggleImageCaption().run()"
        />
        <tbtn
          icon="mdi-image-multiple-outline"
          :active="editor.isActive('imagegallery')"
          title="Галерея изображений"
          @click="setGallery"
        />
        <tbtn
          icon="mdi-handshake-outline"
          :active="editor.isActive('logotypeband')"
          title="Лента логотипов"
          @click="setLogotypeBand"
        />
        <tbtn
          icon="mdi-youtube"
          :active="editor.isActive('youtube')"
          title="Видео с YouTube"
          @click="setYoutube"
        />
        <tbtn
          icon="mdi-video-outline"
          :active="editor.isActive('videohosted')"
          title="Видео с сервера"
          @click="setVideoHosted"
        />
        <tbtn
          icon="mdi-language-css3"
          :active="editor.isActive('flexrow')"
          title="Flex-контейнер"
          @click="setFlexrow"
        />
        <tbtn
          icon="mdi-xml"
          :active="false"
          title="Исходный код"
          @click="toggleHtml"
        />
      </div>
      <div class="sv-texteditor-toolbar-row" v-show="!isHtml">
        <tbtn
          icon="mdi-xml"
          :active="true"
          title="Исходный код"
          @click="toggleHtml"
        />
        <tbtn
          icon="mdi-creation"
          title="Автоформат HTML"
          @click="autoFormatHtml"
        />
      </div>
      <div class="sv-texteditor-toolbar-label">
        {{ tag.description }}
      </div>
    </div>
    <file-manager-dialog
      v-model="fmDialog"
      :selected-path="fmSelectedFileFix"
      src="texteditor"
      :work-dir="fmWorkDir"
      :allowed-extensions="fmDialogAllowedExt"
      @fm-select="fmSelect"
      @fm-close="fmClose"
    />
    <editor-content v-show="isHtml" :editor="editor" />
    <div v-show="!isHtml" ref="monacoEditorCode" class="sv-monaco-editor" id="monaco-editor"></div>
  </div>
</template>

<script>
import * as monaco from "monaco-editor/esm/vs/editor/editor.api.js";
import { computed } from "vue";
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import Youtube from "@tiptap/extension-youtube";
import Tbtn from "./TBtn.vue";
import Notification from "./CustomExtensions/Notification.js";
import ImageCaption from "./CustomExtensions/ImageCaption.js";
import FileAttach from "./CustomExtensions/FileAttach.js";
import ImageGallery from "./CustomExtensions/ImageGallery.js";
import ImageGalleryItem from "./CustomExtensions/ImageGalleryItem.js";
import FlexRow from "./CustomExtensions/FlexRow.js";
import FlexColumn from "./CustomExtensions/FlexColumn.js";
import Logotype from "./CustomExtensions/Logotype.js";
import LogotypeBand from "./CustomExtensions/LogotypeBand.js";
import CustomIframe from "./CustomExtensions/CustomIframe.js";
import VideoHosted from "./CustomExtensions/VideoHosted.js";
import FileManagerDialog from "./../FileManagerDialog/FileManagerDialog.vue";
import UploaderButton from "@/components/UploaderButton.vue";

export default {
  components: {
    EditorContent,
    FileManagerDialog,
    Tbtn,
    UploaderButton
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editor: null,
      editorCode: null,
      fmDialog: false,
      fmDialogType: "",
      fmDialogAllowedExt: [],
      fmSelectedFile: "",
      fmWorkDir: "",
      isHtml: true
    };
  },

  computed: {
    storagePrefix() {
      return this.$store.getters.getStoragePrefix;
    },
    fmSelectedFileFix() {
      return this.fmSelectedFile
        ? this.fmSelectedFile.replace(this.storagePrefix, "")
        : "";
    }
  },

  watch: {
    value(value) {
      const valueFixed = value
        ? value.replace(/<STORAGE>/g, this.storagePrefix)
        : value;

      // изменения прилетели извне редактора RTF?
      const changedOutsideRTF = this.editor.getHTML() !== valueFixed;
      // valueFixed изменилось извне редактора RTF, следовательно надо обновить его в редакторе
      changedOutsideRTF && this.editor.commands.setContent(valueFixed, false);

      // изменения прилетели извне редактора HTML?
      const changedOutsideHTML =
        this.editorCode && this.editorCode.getValue() !== valueFixed;
      // valueFixed изменилось извне редактора HTML, следовательно надо обновить его в редакторе
      changedOutsideHTML && this.editorCode.setValue(valueFixed);
    }
  },

  mounted() {
    // Create RTF editor
    this.editor = new Editor({
      content: this.value,
      extensions: [
        Notification,
        ImageCaption,
        FileAttach,
        ImageGallery,
        ImageGalleryItem,
        FlexRow,
        FlexColumn,
        Logotype,
        LogotypeBand,
        StarterKit,
        Underline,
        Youtube,
        VideoHosted,
        CustomIframe,
        TextAlign.configure({
          types: ["heading", "paragraph"]
        }),
        Link.configure({
          openOnClick: false
        }),
        Image.configure({
          inline: true
        })
      ],
      onUpdate: () => {
        const value = this.editor
          .getHTML()
          .replace(new RegExp(`/${this.storagePrefix}/g`), "<STORAGE>");
        this.$emit("input", value);
      }
    });

    this.editor.imagesUploadDir = "/images";
    if (
      this.tag &&
      this.tag.custom_settings &&
      this.tag.custom_settings.images_dir
    ) {
      this.editor.imagesUploadDir = this.tag.custom_settings.images_dir;
    }
    this.editor.filesUploadDir = "/files";
    if (
      this.tag &&
      this.tag.custom_settings &&
      this.tag.custom_settings.files_dir
    ) {
      this.editor.filesUploadDir = this.tag.custom_settings.files_dir;
    }

    //Create code editor
    const editorCodeOptions = {
      language: "html",
      theme: "vs",
      automaticLayout: true,
      minimap: { enabled: false }
    };

    this.editorCode = monaco.editor.create(
      this.$refs.monacoEditorCode,
      editorCodeOptions
    );

    // привязываем вызов обновления при изменении контента в редакторе значения (печатании)
    this.editorCode.onDidChangeModelContent(() => {
      const value = this.editorCode.getValue();
      this.$emit("input", value);
    });
  },

  beforeDestroy() {
    this.editor.destroy();
    this.editorCode && this.editorCode.dispose();
  },

  methods: {
    setLink() {
      const previousUrl = this.editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        this.editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .unsetLink()
          .run();

        return;
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run();
    },

    setButtonLink() {
      const previousUrl = this.editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        this.editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .unsetLink()
          .run();

        return;
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({
          href: url,
          class: "aunfbutton"
        })
        .run();
    },

    setYoutube() {
      const previousUrl = this.editor.getAttributes("youtube").src;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        return;
      }

      this.editor.commands.setYoutubeVideo({
        src: url,
        width: 640,
        height: 480
      });
    },

    setFileAttach() {
      this.fmSelectedFile = this.editor.getAttributes("fileattach").src;
      this.fmDialogType = "fileattach";
      this.fmDialogAllowedExt = [];
      this.fmWorkDir = this.editor.filesUploadDir;
      this.fmDialog = true;
    },
    setVideoHosted() {
      this.fmSelectedFile = this.editor.getAttributes("videohosted").src;
      this.fmDialogType = "videohosted";
      this.fmDialogAllowedExt = ["mp4"];
      this.fmWorkDir = "video";
      this.fmDialog = true;
    },
    setImage() {
      this.fmSelectedFile = this.editor.getAttributes("image").src;
      this.fmDialogType = "image";
      this.fmDialogAllowedExt = ["jpg", "jpeg", "png", "svg", "gif"];
      this.fmWorkDir = this.editor.imagesUploadDir;
      this.fmDialog = true;
    },
    setGallery() {
      this.editor
        .chain()
        .focus()
        .insertContent({ type: "imagegallery" })
        .run();
    },
    setFlexrow() {
      this.editor
        .chain()
        .focus()
        .insertContent('<div class="aunfrow row"></div>')
        .run();
    },
    setLogotypeBand() {
      this.editor
        .chain()
        .focus()
        .insertContent({ type: "logotypeband" })
        .run();
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmSelect(file) {
      this.fmDialog = false;
      let src = file;
      if (!src.startsWith("/")) src = `/${src}`;
      src = `${this.storagePrefix}${src}`;

      const focus = this.editor.chain().focus();
      switch (this.fmDialogType) {
        case "image":
          focus.setImage({ src }).run();
          break;
        case "fileattach":
          focus.setFileAttach({ src }).run();
          break;
        case "videohosted":
          focus.setVideoHosted({ src }).run();
          break;
      }
    },

    onImageUpload(files) {
      let src = files[0];
      if (!src.startsWith("/")) src = `/${src}`;
      src = `${this.storagePrefix}${src}`;
      const focus = this.editor.chain().focus();
      focus.setImage({ src }).run();
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    },

    toggleHtml() {
      this.isHtml = !this.isHtml;
      if (!this.isHtml) {
        this.$nextTick(() => {
          this.editorCode.getAction("editor.action.formatDocument").run();
        });
      }
    },

    autoFormatHtml() {
      this.editorCode.getAction("editor.action.formatDocument").run();
    }
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
<style lang="scss">
@import "@/styles/branding.scss";
.sv-texteditor-container {
  border: 1px solid $brand-control-border !important;
  border-radius: 4px;
  margin-bottom: 16px !important;
  position: relative;

  .sv-texteditor-toolbar {
    top: 0px;
    position: sticky !important;
    position: -webkit-sticky !important;
    background-color: #ffffff;
    z-index: 3;
    border-bottom: 1px solid $brand-border-table-inner !important;

    .sv-texteditor-toolbar-label {
      font-size: 12px;
      color: $brand-text-placeholder !important;
      padding: 3px 8px 3px 8px;
    }
  }
}
.sv-texteditor-toolbar-row {
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 2px;
  display: flex;
  &:last-of-type {
    padding-bottom: 14px;
  }
}

.sv-monaco-editor {
  width: 100%;
  height: 300px;
}

.ProseMirror {
  outline: none;
  padding: 10px 12px 6px 12px;

  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  h1 {
    font-size: 44px;
  }

  h2 {
    font-size: 32px;
  }

  h3 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 18px;
  }

  h6 {
    font-size: 14px;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: "JetBrainsMono", monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  hr {
    margin: 1rem 0;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }
}
</style>
